export default __webpack_public_path__ + "static/media/login.0895c043.svg";